
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Plus } from "lucide-react";

interface StepManagerProps {
  onAddStep: (stepName: string) => void;
  existingSteps: number[];
  isRestrictedUser?: boolean;
}

const StepManager = ({ onAddStep, existingSteps, isRestrictedUser = false }: StepManagerProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [newStepName, setNewStepName] = useState('');

  const handleAddStep = () => {
    if (newStepName.trim()) {
      onAddStep(newStepName.trim());
      setNewStepName('');
      setIsDialogOpen(false);
    }
  };

  const getNextStepNumber = () => {
    return Math.max(...existingSteps, 0) + 1;
  };

  const handleOpenDialog = () => {
    const nextStepNumber = getNextStepNumber();
    setNewStepName(`Step ${nextStepNumber}`);
    setIsDialogOpen(true);
  };

  return (
    <>
      <Button
        onClick={handleOpenDialog}
        disabled={isRestrictedUser}
        className={`w-[160px] ${
          isRestrictedUser 
            ? "bg-gray-600 text-gray-400 cursor-not-allowed hover:bg-gray-600"
            : "bg-primary hover:bg-primary/90 text-black"
        }`}
      >
        <Plus className="h-4 w-4 mr-2" />
        Add New Step
      </Button>

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="bg-white text-black">
          <DialogHeader>
            <DialogTitle>Add New Step</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <label htmlFor="stepName" className="block text-sm font-medium mb-2">
                Step Name
              </label>
              <Input
                id="stepName"
                className="bg-white text-black"
                value={newStepName}
                onChange={(e) => setNewStepName(e.target.value)}
                placeholder="Enter step name"
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleAddStep();
                  }
                }}
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setIsDialogOpen(false)}
              className="bg-white text-black border-gray-300"
            >
              Cancel
            </Button>
            <Button
              onClick={handleAddStep}
              disabled={!newStepName.trim()}
              className="bg-primary text-primary-foreground"
            >
              Add Step
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default StepManager;
